import { Container, Grid, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Button from '../../UI/Button';
import { Link } from 'react-router-dom';


const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    table: {
        paddingTop: '20px',
        margin: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});

const ComunicadoMenu = ({ navigation }) => {
    const classes = useStyles();

    return (
        <Container className={classes.paper} component={Paper}>
            <Grid
                container
                spacing={3}
            >
                <Grid size={12}>
                    <Typography variant="h6">
                        Comunicado Menu
                    </Typography>
                </Grid>
                <Grid size={8}>
                    <Grid container direction='row' justifyContent='space-around'>
                        <Grid>
                            <Button
                                component={Link}
                                to={{
                                    pathname: '/comunicado'
                                }}
                            >Enviado</Button>
                        </Grid>
                        <Grid>
                            <Button
                                component={Link}
                                to={{
                                    pathname: '/comunicado-aluno'
                                }}
                            >Recebido</Button>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Container>
    );
}

export default ComunicadoMenu;